import React from 'react'
import { Row, Col } from "react-bootstrap";



export default class DetailElement extends React.Component {
	
  	render() {
    	return (<div>
	        {this.props.value ? 
      			<Row >
					<Col style={{backgroundColor: '#ffffff'}}>
						<strong>{this.props.name}</strong>
       				</Col>
					<Col  md="auto" style={{backgroundColor: '#ffffff'}}></Col>
					<Col md={{ span: 11, offset: 1 }} style={{backgroundColor: '#fbfbfb', whiteSpace: 'pre-wrap'}}>
						{this.props.children ? this.props.children : this.props.value}
					</Col>
      		</Row>
			: ""}</div>
			
    )
  }
}





